const getAttrFromJSON = <T>(data: unknown, attr: string) => {
  return typeof data === "string" ? (JSON.parse(data)[attr] as T) : null;
};

export default getAttrFromJSON;
